/**
 * Blog listing video previews.
 *
 * Only the card nearest the vertical centre of the viewport plays.
 * Playback is muted (browser autoplay policy) and loops a short window
 * starting at each video's chosen "main moment".
 * All other cards stay paused on their poster frame.
 */
(function () {
  var SELECTOR = '[data-preview-video]';
  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function startOf(video) {
    var s = parseFloat(video.getAttribute('data-preview-start'));
    return isNaN(s) ? 0 : s;
  }

  function durationOf(video) {
    var d = parseFloat(video.getAttribute('data-preview-duration'));
    return isNaN(d) || d <= 0 ? 12 : d;
  }

  function seekToStart(video) {
    var s = startOf(video);
    if (!video.duration || isNaN(video.duration)) return;
    if (s > 0 && s < video.duration) {
      try {
        video.currentTime = s;
      } catch (e) {
        /* seeking not ready yet */
      }
    }
  }

  function init() {
    var videos = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;

      video.addEventListener('loadedmetadata', function () {
        seekToStart(video);
      });

      // Keep playback within the preview window.
      video.addEventListener('timeupdate', function () {
        var s = startOf(video);
        var d = durationOf(video);
        if (video.currentTime > s + d || video.currentTime < s - 0.5) {
          seekToStart(video);
        }
      });
    });

    if (prefersReduced) return;

    var current = null;

    function playVideo(video) {
      if (video.getAttribute('preload') === 'none') {
        video.setAttribute('preload', 'auto');
      }

      var attempt = function () {
        if (video.readyState >= 1) {
          var s = startOf(video);
          if (Math.abs(video.currentTime - s) > 1.5) seekToStart(video);
        }
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            /* autoplay refused - poster remains visible */
          });
        }
      };

      if (video.readyState >= 2) {
        attempt();
      } else {
        video.addEventListener('loadeddata', attempt, { once: true });
        video.load();
      }
    }

    function selectCentred() {
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var centre = viewportH / 2;
      var best = null;
      var bestDistance = Infinity;

      videos.forEach(function (video) {
        var rect = video.getBoundingClientRect();
        if (rect.height === 0) return;
        if (rect.bottom <= 0 || rect.top >= viewportH) return;

        var visible = Math.min(rect.bottom, viewportH) - Math.max(rect.top, 0);
        if (visible < rect.height * 0.35) return;

        var mid = rect.top + rect.height / 2;
        var distance = Math.abs(mid - centre);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = video;
        }
      });

      if (best === current) return;

      if (current) {
        current.pause();
        current.removeAttribute('data-preview-playing');
      }

      current = best;

      if (current) {
        current.setAttribute('data-preview-playing', '');
        playVideo(current);
      }
    }

    var ticking = false;
    function onChange() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        selectCentred();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onChange, { passive: true });
    window.addEventListener('resize', onChange, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (current) current.pause();
      } else {
        onChange();
      }
    });

    selectCentred();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
